// removed by extract-text-webpack-plugin
module.exports = {"ListItem":"_ri4CM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Meals/MealsPaxSelect/MealsPaxSelect.scss
// module id = 575
// module chunks = 0